// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__kmOvh","button":"style_button__2TLH3","span":"style_span__3etwt","wrapActive":"style_wrapActive__3JSCM"};